import { integrateWithCentroid } from "../math/integrate";
import type { LineLoad } from "../types/input";

/** Çizgisel yük qL (kN/m), duvardan x uzaklıkta; z derinlikte yatay basınç (rijit duvar, 2× çarpanlı Boussinesq). */
export function lineLoadPressure(qL: number, x: number, H: number, z: number): number {
  const m = x / H, n = z / H;
  if (m > 0.4) return ((4 * qL) / (Math.PI * H)) * ((m * m * n) / (m * m + n * n) ** 2);
  return ((0.203 * qL) / H) * (n / (0.16 + n * n) ** 2);
}

/** Şerit yük qs (kN/m²), yakın kenar x, genişlik w; z derinlikte yatay basınç. */
export function stripLoadPressure(qs: number, x: number, w: number, z: number): number {
  if (z <= 1e-12) return 0;
  const t1 = Math.atan(x / z), t2 = Math.atan((x + w) / z);
  const beta = t2 - t1, alpha = (t1 + t2) / 2;
  return ((2 * qs) / Math.PI) * (beta - Math.sin(beta) * Math.cos(2 * alpha));
}

/** Yükün 0..H boyunca yatay kuvveti ve bileşke derinliği (düzlem üstünden). Deprem artımı yoktur. */
export function integrateExternalLoad(load: LineLoad, H: number, n = 200): { F: number; zBar: number } {
  if (load.kind === "strip") {
    const w = load.width;
    if (w === undefined || w <= 0) throw new Error("Şerit yük için genişlik gerekli");
    return integrateWithCentroid((z) => stripLoadPressure(load.magnitude, load.distance, w, z), 0, H, n);
  }
  return integrateWithCentroid((z) => lineLoadPressure(load.magnitude, load.distance, H, z), 0, H, n);
}
